import Color from 'color';
export const convertToDarkRgba = (color) => color && Color(color).darken(0.2).rgb().string();
//# sourceMappingURL=convertToDarkRgba.js.map